import { Grid, IconButton, TextField, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import QrCodeIcon from "@mui/icons-material/QrCode";
import type { ComponentType } from "react";
import QRCodeComponent from "react-qr-code";
import { formatInputValue } from "../../../../../Utils/formatInputValue";
import { simpleConvertToCents } from "../../../../../Utils/formatters";
import CustomButton from "../../CustomButton";
import SaldoCard from "../SaldoCard";

const QRCode = QRCodeComponent as unknown as ComponentType<{ value: string; size?: number }>;

type Props = {
  qrCode: string;
  amount: string | number;
  onCopy: (value: string) => void;
  setAmount: (v: string) => void;
  onCreate: (payload: { amount: number; id: string }) => void;
  subAccountId: string;
};

const QRCodeSection = ({ qrCode, amount, onCopy, setAmount, onCreate, subAccountId }: Props) => (
  <>
    {qrCode ? (
      <Grid container justifyContent="center" flexDirection="column" alignItems="center" spacing={2}>
        <Grid item>
          <QRCode value={qrCode} />
        </Grid>
        <Grid item>
          <TextField
            value={qrCode}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => onCopy(qrCode)} disabled={!qrCode}>
                  <ContentCopyIcon />
                </IconButton>
              ),
            }}
            fullWidth
          />
        </Grid>
        <Grid item>
          <SaldoCard title={""} amount={Number(amount) as number} />
        </Grid>
      </Grid>
    ) : (
      <Grid container justifyContent="center" flexDirection="column" alignItems="center" spacing={2}>
        <Grid item>
          <Typography>Para criar um QRCODE estático insira um valor</Typography>
        </Grid>
        <Grid item>
          <TextField fullWidth label="Valor do qrcode" variant="outlined" name="amont" value={amount} onChange={(e) => setAmount(formatInputValue(e.target.value))} />
        </Grid>
        <Grid item>
          <CustomButton startIcon={<QrCodeIcon />} onClick={() => onCreate({ amount: simpleConvertToCents(String(amount)), id: subAccountId })}>
            Criar QRCODE
          </CustomButton>
        </Grid>
      </Grid>
    )}
  </>
);

export default QRCodeSection;
